import { createIntl, createIntlCache, type IntlShape } from 'react-intl';

import { DEFAULT_LOCALE, Locale } from 'src/constants';
import en from 'src/translations/en.json';

const cache = createIntlCache();

const messages = {
  [Locale.EN]: en,
};

let intl: IntlShape;

export const updateIntl = (locale = DEFAULT_LOCALE) => {
  intl = createIntl(
    {
      locale,
      messages: messages[locale],
    },
    cache,
  );

  return intl;
};

export const getIntl = () => intl;
